module.exports = __webpack_public_path__ + "img/pigeon-peas-350x184.73856999.jpg";